import React from 'react'
import { moneyColumn, numVal } from '../../../modules/Utils'
import { moneyInline } from '../../../modules/Utils'

function PercentCell(props) {
  const { value } = props
  if (value === undefined) return <span />
  else return <span style={props.style}>{numVal({ value }, 'value')} %</span>
}
export default PercentCell
